import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSiteContent } from "@/hooks/useSiteContent";

const darkPromoStyles: React.CSSProperties = {
  "--primary": "43 56% 52%",
  "--primary-foreground": "0 0% 0%",
} as any;

const PromoBanner = () => {
  const { t, content, loading } = useSiteContent();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  const previewDesignId = Number(new URLSearchParams(location.search).get("preview_design") || "0");
  const configuredDesignId = Number(content.homepage_design || "1");
  const effectiveDesignId = previewDesignId > 0 ? previewDesignId : configuredDesignId;
  const isLightDesign = (effectiveDesignId >= 21 && effectiveDesignId <= 30) || effectiveDesignId === 51;

  const text = t("promo_banner_text", "");
  const link = t("promo_banner_link", "");
  const enabled = t("promo_banner_enabled", "");

  // Don't block rendering while loading — just hide if no cached data
  if (loading && !text) {
    return null;
  }

  if (!text || enabled === "false" || dismissed) return null;

  return (
    <div
      className="bg-primary text-primary-foreground relative"
      style={{ ...(isLightDesign ? darkPromoStyles : undefined), minHeight: "40px", containIntrinsicSize: "0 40px", contentVisibility: "visible" }}
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-3">
        {link ? (
          <a href={link} className="text-xs sm:text-sm font-body tracking-wider text-center hover:underline">
            {text}
          </a>
        ) : (
          <p className="text-xs sm:text-sm font-body tracking-wider text-center">{text}</p>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-primary-foreground/20 transition-colors text-sm leading-none"
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
